import doubleOptDialogComponent from './double-opt-dialog.component';
import doubleOptSuccessDialogComponent from './success/double-opt-success-dialog.component';
import doubleOptTimeoutDialogComponent from './timeout/double-opt-timeout-dialog.component';
import doubleOptWarningDialogComponent from './warning/double-opt-warning-dialog.component';

export default angular
  .module('fizyweb.paycell.doubleOpt', [])
  .component('doubleOptDialog', doubleOptDialogComponent)
  .component('doubleOptSuccessDialog', doubleOptSuccessDialogComponent)
  .component('doubleOptTimeoutDialog', doubleOptTimeoutDialogComponent)
  .component('doubleOptWarningDialog', doubleOptWarningDialogComponent).name;



// WEBPACK FOOTER //
// src/app/components/double-opt-dialog/double-opt.module.ts